import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import classNames from "classnames";

interface FadeInProps {
    delay?: number; // Milliseconds before the content appears
    className?: string;
    children: ReactNode;
}

// Fades and slides its children in after `delay` ms
const FadeIn = ({ delay = 0, className, children }: FadeInProps) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setVisible(true), delay);
        return () => clearTimeout(timeout);
    }, [delay]);

    return (
        <div
            className={classNames(
                // Reduced-motion users get the content without the animation
                "transition-all duration-700 ease-out motion-reduce:transition-none",
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4",
                className
            )}
        >
            {children}
        </div>
    );
};

export default FadeIn;